import { KRUMAGO } from '../../../s3-assets/Krumago';

const BridgingTheKnowledgeGap = () => {
  return (
    <section id="section-knowledge-gap" style={{ padding: '4rem 2rem', backgroundColor: '#ffffff', position: 'relative' }}>
      {/* Hero Image Section */}
      <div id="hero-image-container" style={{ position: 'relative', width: '100%', overflow: 'hidden', marginBottom: '4rem' }}>
        <img
          id="hero-image"
          loading="lazy"
          src={KRUMAGO.IMAGES.BRIDGING_THE_KNOWLEDGE_GAP}
          alt="Bridging The Knowledge Gap"
          style={{
            width: '100vw',
            height: 'auto',
            objectFit: 'cover',
            display: 'block',
            marginTop: '-2rem',
          }}
        />
        <div id="hero-text-overlay" style={{ position: 'absolute', top: 0, left: 0, width: '50%', height: '100%', padding: '2rem', color: '#fff', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          <div style={{ width: '100%', padding: '2rem', textAlign: 'left' }}>
            <h2 id="hero-heading" style={{ fontSize: '3.2rem', fontWeight: '700', color: '#fff', fontFamily: 'Poppins, sans-serif', margin: '0 0 1rem 0' }}>
              Bridging the knowledge gap
            </h2>
            <br />
            <h2 id="hero-subheading" style={{ fontSize: '1rem', textAlign: 'justify', fontWeight: '700', fontFamily: 'Poppins, sans-serif', margin: '0', lineHeight: '1.5', color: '#fff' }}>
              The IT industry is a dynamic landscape, constantly evolving with new technologies and trends. This rapid pace often creates a significant knowledge gap between academic learning and real-world industry demands. At AVPS Academy, we're committed to bridging this gap and equipping you with the skills and mindset needed to thrive in the IT world.
            </h2>
          </div>
        </div>
      </div>

      {/* Challenge Section */}
      <div id="challenge-section" style={{ width: '100%', padding: '2rem', marginBottom: '4rem', display: 'flex', alignItems: 'center' }}>
        <img
          id="challenge-image"
          loading="lazy"
          src={KRUMAGO.IMAGES.CHALLENGE}
          alt="Challenge"
          style={{ width: '30%', height: 'auto', marginRight: '1rem' }}
        />
        <div>
          <h2 id="challenge-heading" style={{ fontSize: '4rem', fontWeight: '700', color: 'var(--education-secondary, #3B9394)', fontFamily: 'Poppins, sans-serif' }}>The Challenge</h2>
          <h2 id="challenge-description" style={{ fontSize: '1.3rem', fontWeight: '700', fontFamily: 'Poppins, sans-serif', margin: '0', lineHeight: '1.5' }}>
            Traditional educational institutions often focus on theoretical knowledge, leaving graduates unprepared for the practical challenges of the IT industry. This disconnect can lead to frustration, job dissatisfaction, and a struggle to find meaningful employment.
          </h2>
        </div>
      </div>

      {/* Our Solution Section */}
      <div id="solution-section" style={{ maxWidth: '100%', margin: '0 auto' }}>
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '1rem', marginBottom: '3rem' }}>
          <div style={{ display: 'flex', flexDirection: 'column', maxWidth: '100%' }}>
            <h2 id="solution-heading" style={{ fontSize: '4rem', fontWeight: '700', color: 'var(--education-secondary, #3B9394)' }}>Our Solution</h2>
            <h2 id="solution-description-1" style={{ fontSize: '1.3rem', fontWeight: '700', fontFamily: 'Poppins, sans-serif', margin: '0 0 0 0.5rem' }}>
              <span style={{ color: 'var(--education-primary, #746EAC)' }}>AVPS Academy</span> offers a unique approach to programming education that focuses on practical application,
            </h2>
            <h2 id="solution-description-2" style={{ fontSize: '1.3rem', fontWeight: '700', fontFamily: 'Poppins, sans-serif', margin: '0 auto', textAlign: 'center' }}>
              & industry relevance. Our curriculum is designed to
            </h2>
          </div>
        </div>
      </div>

      {/* Features Boxes */}
      <div id="features-section" style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', padding: '2rem', gap: '1rem', marginBottom: '8rem' }}>
        {[...Array(4)].map((_, index) => (
          <div
            key={index}
            id={`feature-box-${index}`}
            style={{
              width: '300px',
              height: '240px',
              padding: '2rem',
              border: '1px solid #ddd',
              borderRadius: '8px',
              backgroundColor: '#F9F9F9',
              textAlign: 'center',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              transition: 'transform 0.3s ease-in-out',
            }}
            onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
            onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
          >
            <h3 style={{ fontSize: '1.3rem', fontWeight: 'bold', color: 'var(--education-primary, #746EAC)', marginBottom: '1rem' }}>
              {index === 0 ? 'Close the Theory Practice Gap' :
                index === 1 ? 'Industry-Aligned Curriculum' :
                  index === 2 ? 'Mentorship and Guidance' : 'Soft Skills Development'}
            </h3>
            <p style={{ fontSize: '1rem', color: '#666' }}>
              {index === 0 ? 'We bridge the gap between theoretical concepts and real-world problem-solving through hands-on projects and simulations.' :
                index === 1 ? 'Our courses are developed in collaboration with industry experts to ensure they align with current trends and job requirements.' :
                  index === 2 ? 'Our experienced mentors provide personalized support, offering valuable insights and career guidance.' :
                    'We emphasize the importance of communication, teamwork, and problem-solving skills, essential for success in the IT industry.'}
            </p>
          </div>
        ))}
      </div>

      {/* How It Works Section */}
      <div id="how-it-works-section" style={{
        backgroundImage: `url(${KRUMAGO.IMAGES.HOW_IT_WORKS})`,
        backgroundSize: 'cover',
        padding: '4rem 2rem',
        color: '#fff',
        position: 'relative',
        textAlign: 'center',
        marginBottom: '4rem'
      }}>
        <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0, 0, 0, 0.5)', zIndex: 1 }} />
        <div style={{ position: 'relative', zIndex: 2 }}>
          <h2 id="how-it-works-heading" style={{ fontSize: '3rem', marginBottom: '3.5rem' }}>How It Works</h2>
          <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-around', gap: '2rem' }}>
            {['Real-World Projects', 'Industry Experts', 'Certification Preparation'].map((title, idx) => (
              <div
                key={idx}
                id={`how-it-works-card-${idx}`}
                style={{
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  padding: '2rem',
                  borderRadius: '12px',
                  width: '100%',
                  maxWidth: '400px',
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
                  transition: 'transform 0.3s ease'
                }}
                onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
              >
                <h3 style={{ fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '1rem', color: '#FFD700' }}>{title}</h3>
                <p style={{ fontSize: '1rem', color: '#fff' }}>
                  {idx === 0 ? 'Our students work on industry-relevant projects, applying their knowledge to solve real-world challenges.' :
                    idx === 1 ? 'We invite industry professionals to share their experiences and insights, providing students with a firsthand look at the industry.' :
                      'We prepare students for industry-recognized certifications to enhance their career prospects.'}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* CTA */}
      <div id="cta-section" style={{ textAlign: 'center' }}>
        <h2 id="cta-heading" style={{ fontSize: '3.2rem', fontWeight: '600', color: 'var(--education-secondary, #3B9394)', marginBottom: '2rem' }}>Your Success Story Starts Here</h2>
        <h2 id="cta-subheading" style={{ fontSize: '1.2rem', fontWeight: '700', fontFamily: 'Poppins, sans-serif', lineHeight: '1.5', marginBottom: '2rem' }}>
          Join AVPS Academy to gain the skills and confidence needed to excel in the IT industry.
        </h2>
      <button
  onClick={() => window.location.href = '/products'}
  style={{
    left: '60%',
    transform: 'translateX(-50%)',
    padding: '1rem 2.5rem',
    backgroundColor: 'var(--education-primary, #746EAC)',
    color: '#fff',
    borderRadius: '12px',
    border: 'none',
    fontSize: '1.5rem',
    cursor: 'pointer',
    zIndex: 99999,
  }}
>
  Enroll Now
</button>

      </div>
    </section>
  );
};

export default BridgingTheKnowledgeGap;